import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'
import { Box, BoxProps } from '../Box'
import { Slideshow, SlideshowProps } from './Slideshow'

export type SlideshowBoxProps = {
  additionalClassName?: string
  /** Allow scrolling in slides in case their content overflows */
  allowScroll?: boolean
  as?: keyof JSX.IntrinsicElements
} & BoxProps &
  Pick<SlideshowProps, 'size' | 'timer'>

export const SlideshowBox = ({
  additionalClassName,
  allowScroll,
  as: Root = 'div',
  children,
  size,
  timer,
  ...boxProps
}: PropsWithChildren<SlideshowBoxProps>) => (
  <Root className={classNames('relative h-full', additionalClassName)}>
    <Slideshow
      container={({ children: containerChildren, ref }) => (
        <Box
          {...boxProps}
          additionalClassName="h-full mb-30"
          ref={ref}
          scroll={allowScroll}
        >
          <div className="relative flex flex-col h-full">{containerChildren}</div>
        </Box>
      )}
      navigationButtonsClassName="flex mt-auto justify-center"
      size={size}
      timer={timer}
    >
      {children}
    </Slideshow>
  </Root>
)
